import { UIGameMapTileCornerHighlightController } from '../ui_game_map_highlight/UIGameMapTileCornerHighlightController.ts';
import { GameStateEnums } from '../../../../../../shared/GameEnums.ts';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
import { UIGameMapHighlightView } from '../UIGameMapHighlightView.ts';
import { GameAction } from '@colonist/game-base-types';
import { ArrayUtils } from '@colonist/utils';
export class UIGameMapTileCornerHoverController extends UIGameMapTileCornerHighlightController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.GameEnd:
                this.removeHighlights();
                break;
            case UIGameEventEnums.BeginnerHintReceived:
                this.beginnerHintReceived(data);
                break;
            case UIGameEventEnums.BeginnerModeActionUpdated:
                this.onBeginnerModeActionUpdate(data);
                break;
            case UIGameEventEnums.GameStateUpdated:
                this.destroyBeginnerHintView();
                break;
            case UIGameEventEnums.CanvasResized:
                this.onCanvasResize();
                break;
            default:
                break;
        }
    }
    registerHoverAction(hoverAction) {
        this.hoverMechanicActions.push(hoverAction);
    }
    onHoverStateChange(isHoverStateActive) {
        const beginnerHintActive = this.beginnerHintView != undefined;
        if (beginnerHintActive) {
            this.destroyBeginnerHintView();
            this.beginnerHintReceived(this.beginnerHint);
        }
        if (!isHoverStateActive) {
            this.removeHighlights();
            return;
        }
        const previousCorners = [
            ...this.corners
        ];
        const selectedIndex = this.confirmActionController.selectedLocationIndex;
        this.updateCorners();
        const wasEmpty = this.highlightViews.length === 0;
        const hasCorners = this.corners.length > 0;
        if (wasEmpty && hasCorners) {
            this.updateHighlightsDifferentially([], selectedIndex);
        } else if (this.hasCornerChanges(previousCorners)) {
            this.updateHighlightsDifferentially(previousCorners, selectedIndex);
        } else if (hasCorners) {
            this.confirmActionController.setupInvisibleBackground(()=>{
                this.startAnimation();
                this.hideBeginnerHintInformation();
            });
        }
        this.updateHighlightVisibility();
    }
    onHoverHighlightClick() {
        this.onHoverStateChange(true);
        this.endAnimation();
    }
    onHoverHighlightCancellation() {
        this.startAnimation();
    }
    onClickInvisibleBackground() {
        this.confirmActionController.cleanupConfirmation();
    }
    highlight(highlightParameters, action) {
        const highlightView = new UIGameMapHighlightView(this.uiGameManager, highlightParameters, this.uiGameManager.mapController.mapView, action, false, this.shouldHighlightOnlyOnHover);
        if (this.shouldHighlightOnlyOnHover) {
            highlightView.displayOnlyOnHover();
        } else {
            const canAffordAction = this.getMechanicsAssociatedWithCorner(highlightParameters.index).some((mechanic)=>mechanic.canTakeAction);
            highlightView.displayAlwaysOn(canAffordAction);
        }
        this.highlightViews.push(highlightView);
    }
    updateCorners() {
        const newCorners = [];
        this.hoverMechanicActions.forEach((mechanicAction)=>{
            if (!mechanicAction.isCornerAction) return;
            newCorners.push(...mechanicAction.validLocations);
        });
        this.corners = newCorners;
    }
    hasCornerChanges(previousCorners) {
        const cornerChanges = ArrayUtils.arraysEqual(previousCorners.sort(), this.corners.sort());
        return previousCorners.length !== this.corners.length || !cornerChanges;
    }
    getActionForCornerHighlight(highlightParameters, p, index) {
        return ()=>{
            if (!this.isAllowedPlacementIndex(index)) return this.uiGameManager.eventController.sendEvent(undefined, GameStateEnums.UIGameEventEnums.BeginnerModeForceOpenGuideBubble);
            this.uiGameManager.mapController.hoverController.onClickInvisibleBackground();
            const buttonSize = highlightParameters.size * 1.75 * this.buttonScaleForMobile;
            const buttonX = p.x - buttonSize / 2;
            const buttonY = p.y - buttonSize * 1.5;
            this.destroyBeginnerHintView();
            this.uiGameManager.mapController.hoverController.onHoverHighlightClick();
            const cancellationAction = ()=>{
                this.uiGameManager.mapController.hoverController.onHoverHighlightCancellation();
            };
            const confirmationParameters = [];
            const mechanicsAssociatedWithCorner = this.getMechanicsAssociatedWithCorner(index);
            mechanicsAssociatedWithCorner.forEach((mechanic)=>confirmationParameters.push(mechanic.getConfirmationParameters(index)));
            this.confirmActionController.showActionConfirmation(highlightParameters, buttonX, buttonY, buttonSize, cancellationAction, confirmationParameters, index);
        };
    }
    beginnerHintReceived(data) {
        const validGameActions = [
            GameAction.ConfirmBuildSettlement,
            GameAction.ConfirmBuildCity
        ];
        if (!validGameActions.includes(data.type)) return;
        super.beginnerHintReceived(data);
    }
    getMechanicsAssociatedWithCorner(index) {
        const allowedMechanics = [];
        for (const mechanic of this.hoverMechanicActions){
            if (!mechanic.isCornerAction) continue;
            if (mechanic.validLocations.includes(index)) allowedMechanics.push(mechanic);
        }
        return allowedMechanics;
    }
    updateHighlightVisibility() {
        if (this.shouldHighlightOnlyOnHover) return;
        for (const highlightView of this.highlightViews){
            const canAffordAction = this.getMechanicsAssociatedWithCorner(highlightView.highlightedGameElementIndex).some((mechanic)=>mechanic.canTakeAction);
            highlightView.displayAlwaysOn(canAffordAction);
        }
    }
    constructor(uiGameManager, shouldHighlightOnlyOnHover){
        super(uiGameManager);
        this.shouldHighlightOnlyOnHover = shouldHighlightOnlyOnHover;
        this.hoverMechanicActions = [];
    }
}
